<template>
	<el-container>
		<el-main>
			<el-card shadow="never">
				<el-row :gutter="10" class="top_l">
					<el-col :span="5" :xs="24"><el-input v-model="code" clearable
							placeholder="请输入编码"></el-input></el-col>
					<el-col :span="19" :xs="24" class="elel">
						<el-button type="primary" @click="gameShare">搜索</el-button>
						<el-button type="primary" style="margin-left: 20px;" @click="handleAdd">新增</el-button>
						<el-button type="primary" style="margin-left: 20px;" @click="refreshCache">刷新缓存</el-button>
						<div class="readbox">
							<el-tag size="large">查询是否可用：</el-tag>
							<el-radio-group v-model="status" @change="radioes">
								<el-radio label="" border>全部</el-radio>
								<el-radio :label="1" border>是</el-radio>
								<el-radio :label="0" border>否</el-radio>
							</el-radio-group>
						</div>
					</el-col>
				</el-row>
				<!-- table 表格 -->
				<el-table v-loading="serloading" :data="tableData" :header-cell-style="{ background: '#eef1f6' }" border
					stripe>
					<el-table-column prop="code" label="编码" width="400"></el-table-column>
					<el-table-column label="值" width="500">
						<template v-slot="scope">
							<span style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;display: block;">
								{{ scope.row.value }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="comment" label="描述" width="400"></el-table-column>
					<el-table-column label="是否可用" width="86">
						<template v-slot="scope">
							<el-switch @change="switchClick(scope.row)" v-model="scope.row.status" class="mb-2"
								style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" :active-value="1"
								:inactive-value="0" active-text="是" inactive-text="否" />
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
					<el-table-column prop="updateTime" label="更新时间" width="200"></el-table-column>
					<el-table-column label="操作" align="center" width="250">
						<template v-slot="scope">
							<el-button size="small" type="primary" plain @click="clcedit(scope.row)">编辑</el-button>
							<el-button size="small" type="primary" plain @click="clccopy(scope.row)">复制</el-button>
                               
							<el-button size="small" type="primary" plain @click="clcdelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
					<template #empty>
						<el-empty :description="emptyText" :image-size="100"></el-empty>
					</template>
				</el-table>
				<!-- 分页 -->
				<div class="pagin">
					<el-pagination :small="true" v-model:currentPage="currentPage" v-model:page-size="pageSize"
						:page-sizes="[10, 20, 50, 100]" background layout="total, sizes, prev, pager, next, jumper"
						:total="+totals" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
				</div>
				<!-- 新增/编辑/复制 融合 dialog -->
				<el-dialog v-model="dialogVisible" :title="dialogTitle" width="50%" :fullscreen="fullscreenshow">
					<el-form :model="dialogForm" :rules="rules" ref="dialogFormRef" label-width="110px" class="demo-ruleForm">
						<el-row :gutter="20">
							<el-col :span="12" :xs="24">
								<el-form-item label="编码" prop="code">
									<el-input :disabled="dialogMode==='edit'" placeholder="请输入编码" v-model="dialogForm.code"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12" :xs="24">
								<el-form-item label="描述" prop="comment">
									<el-input placeholder="请输入描述" v-model="dialogForm.comment"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12" :xs="24">
								<el-form-item label="值" prop="value">
									<el-input type="textarea" :rows="4" placeholder="请输入值" v-model="dialogForm.value"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<template #footer>
						<span class="dialog-footer">
							<el-button type="primary" @click="verification(dialogForm.value)">验证</el-button>
							<el-button type="primary" @click="handleDialogSubmit">提交</el-button>
							<el-button @click="handleDialogCancel">取消</el-button>
						</span>
					</template>
				</el-dialog>
			</el-card>
		</el-main>
	</el-container>
</template>

<script>
export default {
	name: 'gameConfig',
	data() {
		return {
			fullscreenshow: false,
			emptyText: '暂无数据',
			currentPage: 1,
			pageSize: 10,
			tableData: [],
			totals: null,
			serloading: false,
			code: '',
			status: '',
		// 融合 dialog 控制
		dialogVisible: false,
		dialogMode: 'add', // add/edit/copy
		dialogForm: {
			id: '',
			code: '',
			value: '',
			comment: ''
		},
		dialogTitle: '',
			rules: {
				code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
				value: [{ required: true, message: '请输入值', trigger: 'blur' }],
				comment: [{ required: true, message: '请输入描述', trigger: 'blur' }]
			},
		// 旧表单数据已融合到 dialogForm
			options: [],
		};
	},
	computed: {
	},
	created() {
		if (document.body.clientWidth < 768) {
			this.fullscreenshow = true;
		} else {
			this.fullscreenshow = false;
		}
		// 获取通用配置
		this.ConfigInfo();
		// 获取产品类型
		this.$HTTP.post('index/queryProduct', {}, response => {
			if (response.status >= 200 && response.status < 300) {
				if (response.data.code == 0) {
					this.options = response.data.data;
				} else {
					this.$message.error(response.data.msg);
				}
			} else {
				console.log(response.message);
			}
		});
	},
	methods: {
		// 验证
		verification(res) {
			try {
				var obj = JSON.parse(res);
				console.log(obj,res,22222)
				if (typeof obj == 'object' && obj) {
					alert('格式正确');
				} else {
					alert('格式错误');
				}
			} catch (error) {
				alert('格式错误');
			}
		},
		// 获取通用配置
		ConfigInfo() {
			this.serloading = true;
			this.$HTTP.post(
				'businessConfigInfo/query',
				{
					productId: 'generic',
					code: this.code,
					status: this.status,
					pageNumber: this.currentPage,
					pageSize: this.pageSize
				},
				response => {
					if (response.status >= 200 && response.status < 300) {
						if (response.data.code == 0) {
							this.tableData = response.data.data.records;
							this.totals = response.data.data.total;
							this.serloading = false;
						} else {
							this.$message.error(response.data.msg);
						}
					} else {
						console.log(response.message);
					}
				}
			);
		},
		// 重置
		resetClick(name) {
			this.$refs[name].resetFields();
		},
		// 搜索
		gameShare() {
			this.currentPage = 1;
			// 获取通用配置
			this.ConfigInfo();
		},
		// 刷新缓存
		refreshCache() {
			this.serloading = true;
			this.$HTTP.post('businessConfigInfo/refreshCache',
				{
					productId: 'generic',
				},
				response => {
					if (response.status >= 200 && response.status < 300) {
						if (response.data.code == 0) {
							this.serloading = false;
							this.$message.success(response.data.msg);
						} else {
							this.$message.error(response.data.msg);
						}
					} else {
						console.log(response.message);
					}
				});
		},
		//查新是否可用
		radioes() {
			this.currentPage = 1;
			this.ConfigInfo();
		},
		// 是否可用
		switchClick(row) {
			this.$HTTP.post(
				'businessConfigInfo/updateStatus',
				{
					id: row.id,
					status: row.status
				},
				response => {
					if (response.status >= 200 && response.status < 300) {
						if (response.data.code == 0) {
							this.$message.success(response.data.msg);
							// 获取配置
							this.ConfigInfo();
						} else {
							this.$message.error(response.data.msg);
						}
					} else {
						console.log(response.message);
					}
				}
			);
		},
		// 打开融合 dialog
		openDialog(mode, row = null) {
			this.dialogMode = mode;
			this.dialogVisible = true;
			if (mode === 'add') {
				this.dialogTitle = '新增配置';
				this.dialogForm = { id: '', code: '', value: '', comment: '' };
			} else if (mode === 'edit') {
				this.dialogTitle = '修改配置';
				this.dialogForm = { id: row.id, code: row.code, value: row.value, comment: row.comment };
			} else if (mode === 'copy') {
				this.dialogTitle = '复制配置';
				this.dialogForm = { id: row.id, code: row.code, value: row.value, comment: row.comment };
			}
		},
		// 触发按钮
		clcedit(row) {
			this.openDialog('edit', row);
		},
		clccopy(row) {
			this.openDialog('copy', row);
		},
		// 新增按钮
		handleAdd() {
			this.openDialog('add');
		},
		// 融合提交
		handleDialogSubmit() {
			this.$refs.dialogFormRef.validate(valid => {
				if (!valid) return false;
				if (this.dialogMode === 'add' || this.dialogMode === 'copy') {
					this.$HTTP.post(
						'businessConfigInfo/add',
						{
							code: this.dialogForm.code,
							value: this.dialogForm.value,
							comment: this.dialogForm.comment,
							productId: 'generic',
						},
						response => {
							if (response.status >= 200 && response.status < 300) {
								if (response.data.code == 0) {
									this.dialogVisible = false;
									this.$message.success(response.data.msg);
									this.ConfigInfo();
								} else {
									this.$message.error(response.data.msg);
								}
							} else {
								console.log(response.message);
							}
						}
					);
				} else if (this.dialogMode === 'edit') {
					this.$HTTP.post(
						'businessConfigInfo/update',
						{
							id: this.dialogForm.id,
							code: this.dialogForm.code,
							comment: this.dialogForm.comment,
							value: this.dialogForm.value
						},
						response => {
							if (response.status >= 200 && response.status < 300) {
								if (response.data.code == 0) {
									this.dialogVisible = false;
									this.$message.success(response.data.msg);
									this.ConfigInfo();
								} else {
									this.$message.error(response.data.msg);
								}
							} else {
								console.log(response.message);
							}
						}
					);
				}
			});
		},
		handleDialogCancel() {
			this.dialogVisible = false;
		},
		// 删除
		clcdelete(row) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$HTTP.post(
					'businessConfigInfo/delete',
					{
						id: row.id
					},
					response => {
						if (response.status >= 200 && response.status < 300) {
							if (response.data.code == 0) {
								this.$message.success(response.data.msg);
								// 获取通用配置
								this.ConfigInfo();
							} else {
								this.$message.error(response.data.msg);
							}
						} else {
							console.log(response.message);
						}
					}
				);
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		// 分页
		handleSizeChange(val) {
			this.currentPage = 1;
			this.pageSize = val;
			// 获取通用配置
			this.ConfigInfo();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			// 获取通用配置
			this.ConfigInfo();
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.readbox {
	display: flex;
	margin-left: 20px;
	align-items: center;

	span {
		margin-right: 10px;
		font-size: 16px;
	}
}

.elel {
	display: flex;
	align-items: center;
}
</style>
